// extracted by mini-css-extract-plugin
export default {"loginFormWrapper":"Login_loginFormWrapper__3GY9q","loginForm":"Login_loginForm__zZ2H6","logo":"Login_logo__da2O3","hero":"Login_hero__v4gIG","heroTitle":"Login_heroTitle__Xqk7n"};